import axios from "axios";
const axiosInstance = axios.create({
  // 逻辑：优先读环境变量，读不到就用后面这个字符串
  baseURL: process.env.VUE_APP_API_URL,
});
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const verification = (form) => axiosInstance.post("/api/verification", form);
export const register = (form) => axiosInstance.post("/api/register", form);

